// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/font/Acumin-pro/AcuminPro-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/font/Acumin-pro/AcuminPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/font/Maitree/Maitree-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/font/Maitree/Maitree-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/font/Maitree/Maitree.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Assets/font/Maitree/Maitree.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Assets/font/Maitree/Maitree-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Assets/font/Maitree/Maitree-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black: #000000;
  --white: #ffffff;
  --darkGreen: #042835;
  --lightBlack: #021A22;
  --green:#062A37;
  --primeryColor: #91D9B9; 
  --redColor: #FF2C2C;
  --whiteLight:rgb(255, 255, 255, 40%);
  --boxShadowColor: rgb(255, 255, 255, 25%);
  --sideBarBorderBottom: rgb(255, 255, 255, 20%);
  --selectOptionActiveColor: rgba(145, 217, 184, 0.2);
  --graphTextColor: rgb(255 255 255/0.7);
  --pinkColor: #FFA6C7;
}
*{
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

@font-face {
  font-family: 'Acumin Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Maitree';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Maitree';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Maitree';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
body {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: 'Acumin Pro' ;
  font-size: 16px;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
background: #f1f1f1; 
}

/* Handle */
::-webkit-scrollbar-thumb {
background: rgb(145 217 185 / 60%); 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
background: var(--primeryColor); 
}
h1.MuiTypography-root,h2.MuiTypography-root,h3.MuiTypography-root,h4.MuiTypography-root,h5.MuiTypography-root,h6.MuiTypography-root{
  font-family: 'Maitree';
  font-weight: 700;
}
h1.MuiTypography-root{
  font-size: 50px;
}
h2.MuiTypography-root{
  font-size: 46px;
}
h3.MuiTypography-root{
  font-size: 40px;
}
h4.MuiTypography-root{
  font-size: 28px;
}
h5.MuiTypography-root{
  font-size: 24px;
}
h6.MuiTypography-root{
  font-size: 16px;
}
p.MuiTypography-root {
  margin: 0px;
  padding: 0px;
  font-family: 'Acumin Pro';
}
.delete-btn-color{
  background-color: var(--redColor);
  color: var(--white);
}
.text-primery,
a.text-primery{
  color: var(--primeryColor);
}
.bg-darkGreen{
  background-color: var(--darkGreen);
}
.text-white,
a.text-white{
  color: var(--white);
}
a:hover{
  color: var(--primeryColor);
}
.text--right {
  text-align: right;
}
.text--left{
  text-align: left;
}
.graph-text{
  color: var(--graphTextColor);
}
.form-group{
  margin-bottom: 1.2rem;
}
.no-underline{
  text-decoration: none !important;
}
.border-bottom .line{
  position: relative;
  margin-bottom: 2px;
  display: inline-block;
  padding-bottom: 2px;
}
.border-bottom .line::after{
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  border-bottom: 1px solid var(--white);
  opacity: 50%;
}
.input-box>div {
  width: 100%;
}
.error-message {
  font-size: 14px;
  color: var(--redColor);
  text-align: right;
  margin-top: 5px;
}
.title-with-border {
  border-bottom: 1px solid var(--whiteLight);
}
.MuiFormControl-root{
  width: 100%;
}
.btn-wrapper {
  width: 100%;
}
.profile-modal {
  overflow: auto;
}
.profile-modal .modal-shadow {
  background-color: #042835;
  padding: 32px;
  border-radius: 20px;
}
.profile-modal .input-box .input-label, 
.profile-modal .select-opation--wrapper > div label {
  font-family: 'Acumin Pro';
  transform: none;
}
.cstm-phone--input input.PhoneInputInput::placeholder{
  color: var(--whiteLight);
  font-family: 'Acumin Pro';
}
.profile-modal .modal-header h4 {
  font-weight: 400;
}
.input-box .MuiFormControl-root input {
  padding: 0.72rem 1rem;
  -webkit-text-fill-color: var(--white);
  border-radius: 6px;
}

.form-group .select-opation--wrapper .MuiOutlinedInput-root {
  padding-top: 4px;
  padding-bottom: 4px;
}
.input-box .MuiInputBase-root.Mui-focused input{
  border-color: var(--primeryColor);
}
.profile-btn button:hover {
  border-color: var(--primeryColor);
  color: var(--primeryColor);
}
.btn-font-small .btn-wrapper button,
.btn-font-small .btn-wrapper button:hover {
  font-size: 16px;
  text-wrap: nowrap;
}
.btn-wrapper button.btn-small.only-icon-btn{
  min-width: 50px;
}
.btn-wrapper button.outline-btn {
  background: transparent;
  border: 1px solid var(--whiteLight);
  color: var(--whiteLight);
}
.select-opation--wrapper .MuiAutocomplete-popper{
  box-shadow: 0 4px 10px var(--boxShadowColor);
}
.select-opation--wrapper .MuiAutocomplete-popper>div{
  background-color: var(--darkGreen);
}
.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option {
  color: var(--whiteLight);
  border-bottom: 1px solid var(--whiteLight);
  padding-top: 10px;
  padding-bottom: 10px;
}
.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option:last-child{
  border-bottom: none;
}
.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option:hover,
.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true'],
.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true'] .Mui-focused {
  background-color: var(--selectOptionActiveColor);
  color: var(--white);
}

.profile-modal .modal-header svg {
  width: 26px;
}
.toggle-btn-box .MuiButtonBase-root,
.profile-modal .modal-header .MuiButtonBase-root {
  min-width: 40px;
}
.main-card{
  background-color: var(--darkGreen);
  border: 1px solid var(--whiteLight);
  border-radius: 5px;
  height: 100%;
}
.main-card-header{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 1rem;
  gap: 0.845rem;
}
.main-card-body,
.main-card-footer {
  padding: 10px 1rem;
}
.main-card-body img{
  width: 100%;
}
.border-separate .MuiDivider-root {
  border-color: rgb(255 255 255/0.2);
}
.border-bottom-2{
  border-bottom: 2px solid rgb(255 255 255/0.1);
}
.dialog-component .MuiPaper-elevation {
  background: var(--darkGreen);
  color: var(--white);
  box-shadow: 0 4px 10px rgb(255 255 255/0.1);
  text-align: center;
  width: 100%;
}
.dialog-component .MuiPaper-elevation .text-white p{
  font-size: 20px;
  color: rgb(255 255 255/0.8);
}
.dialog-component .MuiPaper-elevation .modal-title {
  color: var(--primeryColor);
  border-bottom: 1px solid var(--whiteLight);
}
.dialog-component .MuiPaper-elevation .MuiDialogContent-root {
  padding-top: 1rem;
}

button.btn-delete,
.dialog-component .MuiPaper-elevation button.cancel-btn {
  background: var(--redColor);
  color: var(--white);
}
button.btn-delete,
.dialog-component .MuiPaper-elevation button.cancel-btn {
  background: var(--redColor);
  color: var(--white);
}
button.btn-primary,
.dialog-component .MuiPaper-elevation  button.primary-btn {
  background: var(--primeryColor);
  color: var(--darkGreen);
}
button.btn-primary:hover,
.dialog-component .MuiPaper-elevation  button.primary-btn:hover{
  background: var(--primeryColor);
  color: var(--darkGreen);
  opacity: 0.8;
}
button.btn-delete:hover,
.dialog-component .MuiPaper-elevation button.cancel-btn:hover {
  background: var(--redColor);
  color: var(--white);
  opacity: 0.8;
}
.cstm-toggle-btn .MuiSwitch-colorPrimary.Mui-checked {
  color: var(--primeryColor);
}
.cstm-toggle-btn .MuiSwitch-colorPrimary.Mui-checked+.MuiSwitch-track{
  background-color: var(--primeryColor);
}
.dialog-component .MuiPaper-elevation .modal-title:empty{
  display: none;
}
.dialog-component .MuiPaper-elevation .modal-title:empty+.MuiDialogContent-root{
  padding: 35px 1.5rem;
}
.dialog-component .MuiDialogActions-root.MuiDialogActions-spacing {
  padding: 0 1.5rem 25px 1.5rem;
  justify-content: center;
}
.dialog-component .MuiPaper-elevation .MuiDialogContent-root svg {
  width: 90px;
  height: 90px;
  margin: 30px auto;
}
.dialog-component .MuiPaper-elevation .MuiDialogContent-root svg path {
  fill: #FFC548;
}
.border-underline {
  padding-bottom: 4px;
  position: relative;
}
.border-underline::after {
  content: "";
  border-bottom: 1px solid;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,8CAA8C;EAC9C,mDAAmD;EACnD,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB;4DACyE;EACzE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB;4DACmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;4DAC4D;EAC5D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;4DACiE;EACjE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;AACA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;AACA,mBAAmB;AACnB;;AAEA,WAAW;AACX;AACA,kCAAkC;AAClC;;AAEA,oBAAoB;AACpB;AACA,+BAA+B;AAC/B;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;EAEE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX","sourcesContent":[":root {\n  --black: #000000;\n  --white: #ffffff;\n  --darkGreen: #042835;\n  --lightBlack: #021A22;\n  --green:#062A37;\n  --primeryColor: #91D9B9; \n  --redColor: #FF2C2C;\n  --whiteLight:rgb(255, 255, 255, 40%);\n  --boxShadowColor: rgb(255, 255, 255, 25%);\n  --sideBarBorderBottom: rgb(255, 255, 255, 20%);\n  --selectOptionActiveColor: rgba(145, 217, 184, 0.2);\n  --graphTextColor: rgb(255 255 255/0.7);\n  --pinkColor: #FFA6C7;\n}\n*{\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'Acumin Pro';\n  src: url('./Assets/font/Acumin-pro/AcuminPro-Regular.woff2') format('woff2'),\n      url('./Assets/font/Acumin-pro/AcuminPro-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Maitree';\n  src: url('./Assets/font/Maitree/Maitree-Medium.woff2') format('woff2'),\n      url('./Assets/font/Maitree/Maitree-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Maitree';\n  src: url('./Assets/font/Maitree/Maitree.woff2') format('woff2'),\n      url('./Assets/font/Maitree/Maitree.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Maitree';\n  src: url('./Assets/font/Maitree/Maitree-Bold.woff2') format('woff2'),\n      url('./Assets/font/Maitree/Maitree-Bold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\nbody {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n  font-family: 'Acumin Pro' ;\n  font-size: 16px;\n}\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\nbackground: #f1f1f1; \n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\nbackground: rgb(145 217 185 / 60%); \n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\nbackground: var(--primeryColor); \n}\nh1.MuiTypography-root,h2.MuiTypography-root,h3.MuiTypography-root,h4.MuiTypography-root,h5.MuiTypography-root,h6.MuiTypography-root{\n  font-family: 'Maitree';\n  font-weight: 700;\n}\nh1.MuiTypography-root{\n  font-size: 50px;\n}\nh2.MuiTypography-root{\n  font-size: 46px;\n}\nh3.MuiTypography-root{\n  font-size: 40px;\n}\nh4.MuiTypography-root{\n  font-size: 28px;\n}\nh5.MuiTypography-root{\n  font-size: 24px;\n}\nh6.MuiTypography-root{\n  font-size: 16px;\n}\np.MuiTypography-root {\n  margin: 0px;\n  padding: 0px;\n  font-family: 'Acumin Pro';\n}\n.delete-btn-color{\n  background-color: var(--redColor);\n  color: var(--white);\n}\n.text-primery,\na.text-primery{\n  color: var(--primeryColor);\n}\n.bg-darkGreen{\n  background-color: var(--darkGreen);\n}\n.text-white,\na.text-white{\n  color: var(--white);\n}\na:hover{\n  color: var(--primeryColor);\n}\n.text--right {\n  text-align: right;\n}\n.text--left{\n  text-align: left;\n}\n.graph-text{\n  color: var(--graphTextColor);\n}\n.form-group{\n  margin-bottom: 1.2rem;\n}\n.no-underline{\n  text-decoration: none !important;\n}\n.border-bottom .line{\n  position: relative;\n  margin-bottom: 2px;\n  display: inline-block;\n  padding-bottom: 2px;\n}\n.border-bottom .line::after{\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  border-bottom: 1px solid var(--white);\n  opacity: 50%;\n}\n.input-box>div {\n  width: 100%;\n}\n.error-message {\n  font-size: 14px;\n  color: var(--redColor);\n  text-align: right;\n  margin-top: 5px;\n}\n.title-with-border {\n  border-bottom: 1px solid var(--whiteLight);\n}\n.MuiFormControl-root{\n  width: 100%;\n}\n.btn-wrapper {\n  width: 100%;\n}\n.profile-modal {\n  overflow: auto;\n}\n.profile-modal .modal-shadow {\n  background-color: #042835;\n  padding: 32px;\n  border-radius: 20px;\n}\n.profile-modal .input-box .input-label, \n.profile-modal .select-opation--wrapper > div label {\n  font-family: 'Acumin Pro';\n  transform: none;\n}\n.cstm-phone--input input.PhoneInputInput::placeholder{\n  color: var(--whiteLight);\n  font-family: 'Acumin Pro';\n}\n.profile-modal .modal-header h4 {\n  font-weight: 400;\n}\n.input-box .MuiFormControl-root input {\n  padding: 0.72rem 1rem;\n  -webkit-text-fill-color: var(--white);\n  border-radius: 6px;\n}\n\n.form-group .select-opation--wrapper .MuiOutlinedInput-root {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.input-box .MuiInputBase-root.Mui-focused input{\n  border-color: var(--primeryColor);\n}\n.profile-btn button:hover {\n  border-color: var(--primeryColor);\n  color: var(--primeryColor);\n}\n.btn-font-small .btn-wrapper button,\n.btn-font-small .btn-wrapper button:hover {\n  font-size: 16px;\n  text-wrap: nowrap;\n}\n.btn-wrapper button.btn-small.only-icon-btn{\n  min-width: 50px;\n}\n.btn-wrapper button.outline-btn {\n  background: transparent;\n  border: 1px solid var(--whiteLight);\n  color: var(--whiteLight);\n}\n.select-opation--wrapper .MuiAutocomplete-popper{\n  box-shadow: 0 4px 10px var(--boxShadowColor);\n}\n.select-opation--wrapper .MuiAutocomplete-popper>div{\n  background-color: var(--darkGreen);\n}\n.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option {\n  color: var(--whiteLight);\n  border-bottom: 1px solid var(--whiteLight);\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option:last-child{\n  border-bottom: none;\n}\n.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option:hover,\n.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true'],\n.select-opation--wrapper .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true'] .Mui-focused {\n  background-color: var(--selectOptionActiveColor);\n  color: var(--white);\n}\n\n.profile-modal .modal-header svg {\n  width: 26px;\n}\n.toggle-btn-box .MuiButtonBase-root,\n.profile-modal .modal-header .MuiButtonBase-root {\n  min-width: 40px;\n}\n.main-card{\n  background-color: var(--darkGreen);\n  border: 1px solid var(--whiteLight);\n  border-radius: 5px;\n  height: 100%;\n}\n.main-card-header{\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 10px 1rem;\n  gap: 0.845rem;\n}\n.main-card-body,\n.main-card-footer {\n  padding: 10px 1rem;\n}\n.main-card-body img{\n  width: 100%;\n}\n.border-separate .MuiDivider-root {\n  border-color: rgb(255 255 255/0.2);\n}\n.border-bottom-2{\n  border-bottom: 2px solid rgb(255 255 255/0.1);\n}\n.dialog-component .MuiPaper-elevation {\n  background: var(--darkGreen);\n  color: var(--white);\n  box-shadow: 0 4px 10px rgb(255 255 255/0.1);\n  text-align: center;\n  width: 100%;\n}\n.dialog-component .MuiPaper-elevation .text-white p{\n  font-size: 20px;\n  color: rgb(255 255 255/0.8);\n}\n.dialog-component .MuiPaper-elevation .modal-title {\n  color: var(--primeryColor);\n  border-bottom: 1px solid var(--whiteLight);\n}\n.dialog-component .MuiPaper-elevation .MuiDialogContent-root {\n  padding-top: 1rem;\n}\n\nbutton.btn-delete,\n.dialog-component .MuiPaper-elevation button.cancel-btn {\n  background: var(--redColor);\n  color: var(--white);\n}\nbutton.btn-delete,\n.dialog-component .MuiPaper-elevation button.cancel-btn {\n  background: var(--redColor);\n  color: var(--white);\n}\nbutton.btn-primary,\n.dialog-component .MuiPaper-elevation  button.primary-btn {\n  background: var(--primeryColor);\n  color: var(--darkGreen);\n}\nbutton.btn-primary:hover,\n.dialog-component .MuiPaper-elevation  button.primary-btn:hover{\n  background: var(--primeryColor);\n  color: var(--darkGreen);\n  opacity: 0.8;\n}\nbutton.btn-delete:hover,\n.dialog-component .MuiPaper-elevation button.cancel-btn:hover {\n  background: var(--redColor);\n  color: var(--white);\n  opacity: 0.8;\n}\n.cstm-toggle-btn .MuiSwitch-colorPrimary.Mui-checked {\n  color: var(--primeryColor);\n}\n.cstm-toggle-btn .MuiSwitch-colorPrimary.Mui-checked+.MuiSwitch-track{\n  background-color: var(--primeryColor);\n}\n.dialog-component .MuiPaper-elevation .modal-title:empty{\n  display: none;\n}\n.dialog-component .MuiPaper-elevation .modal-title:empty+.MuiDialogContent-root{\n  padding: 35px 1.5rem;\n}\n.dialog-component .MuiDialogActions-root.MuiDialogActions-spacing {\n  padding: 0 1.5rem 25px 1.5rem;\n  justify-content: center;\n}\n.dialog-component .MuiPaper-elevation .MuiDialogContent-root svg {\n  width: 90px;\n  height: 90px;\n  margin: 30px auto;\n}\n.dialog-component .MuiPaper-elevation .MuiDialogContent-root svg path {\n  fill: #FFC548;\n}\n.border-underline {\n  padding-bottom: 4px;\n  position: relative;\n}\n.border-underline::after {\n  content: \"\";\n  border-bottom: 1px solid;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
